import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';
import { getLatestUpdatedAt } from '../../helper/reducer.helper';
import { TextTemplateTagEntity } from '../../entities/text-template-tag.entity';
import { TextTemplateTagActionTypes } from '../actions/text-template-tag.actions';



export const TEXT_TEMPLATE_TAG_KEY = 'textTemplateTag';

export interface TextTemplateTagState extends EntityState<TextTemplateTagEntity> {
    fetched: boolean;
    latestUpdatedAt: Date;
}

const adapter = createEntityAdapter<TextTemplateTagEntity>({
    selectId: (Entity) => Entity.Id,
});

const initialState = adapter.getInitialState({
    fetched: false,
    latestUpdatedAt: null,
});

export const textTemplateTagReducer = createReducer(
    initialState,
    on(TextTemplateTagActionTypes.UpdateAll, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setAll(Payload, { ...state }/*, fetched: true, latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt }*/),
    ),
    on(TextTemplateTagActionTypes.UpdateOne, (state, { Payload }) => adapter.setOne(Payload, state)),
    on(TextTemplateTagActionTypes.CreateSuccess, (state, { Payload }) => adapter.addOne(Payload, state)),
    on(TextTemplateTagActionTypes.RemoveOne, (state, { Payload }) => adapter.removeOne(Payload, state)),
    on(TextTemplateTagActionTypes.UpdateMany, (state, { Payload, updateLatestUpdatedAt }) =>
        adapter.setMany(Payload, {
            ...state,
            latestUpdatedAt: updateLatestUpdatedAt ? getLatestUpdatedAt(Payload, state.latestUpdatedAt) : state.latestUpdatedAt,
        }),
    ),
);

/* ############### */
/* ## SELECTORS ## */
/* ############### */

const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();

export const selectAllTextTemplateTag = selectAll;
export const selectTextTemplateTagEntities = selectEntities;

export const selectTextTemplateTagFetched = (state: TextTemplateTagState) => state.fetched;
export const selectTextTemplateTagLatestUpdatedAt = (state: TextTemplateTagState) => state.latestUpdatedAt;
